import { useTranslation } from 'react-i18next';
import { EngagementPostDetail, Maybe } from '@anytag/graphql';
import { ControlPostDetailsModalType } from '@anytag/shared-hooks';
import { PostModal, usePostModalContext } from '../shared';
import { HistoryTemplate } from './history-template';
import { DetailsTemplate, DetailsTemplateProps } from './details-template';

enum TabType {
  Details = 'Details',
  History = 'History'
}

export interface TemplateProps<T extends ControlPostDetailsModalType>
  extends Pick<DetailsTemplateProps, 'hasTrafficSource'> {
  hidePostHistory?: boolean;
  footer?:
    | React.ReactNode
    | ((props: {
        selectedPost?: T | null;
        tab: keyof typeof TabType;
        postDetails?: Maybe<EngagementPostDetail>;
      }) => React.ReactNode);
}

export const Template = <T extends ControlPostDetailsModalType>({
  footer,
  hidePostHistory,
  hasTrafficSource
}: TemplateProps<T>) => {
  const { t } = useTranslation();
  const { selectedPost } = usePostModalContext<T>();

  return (
    <PostModal.Tabs
      defaultTab={TabType.Details}
      tabs={[
        { label: t('Post Detail'), value: TabType.Details },
        ...(!hidePostHistory ? [{ label: t('History'), value: TabType.History }] : [])
      ]}
    >
      {({ selectedTab }) =>
        selectedTab === TabType.History && !hidePostHistory ? (
          <HistoryTemplate />
        ) : (
          <DetailsTemplate
            hasTrafficSource={hasTrafficSource}
            footer={({ postDetails }) =>
              footer
                ? typeof footer === 'function'
                  ? footer({ tab: selectedTab, selectedPost, postDetails })
                  : footer
                : undefined
            }
          />
        )
      }
    </PostModal.Tabs>
  );
};
